/* ==========================================================================
   WOD.LOL — fiche produit v2
   - ligne « OVERSIZE · DÉLAVÉ · 285 G/M² » + grille « L'essentiel » (data-* de wl-facet-data)
   - Glo Swatch : libellés en français + valeur choisie, conseil taille (« Ma taille » mémorisée
     dans les filtres de collection → taille conseillée selon la coupe)
   - libellés de taille par produit (métachamp custom.libelles_tailles → window.WL_SIZE_LABELS,
     posé par wl-sticky-atc) : ex. t-shirt enfant XS → « 3-4 ans »
   - réassurance : ce qu'il manque pour la livraison offerte selon le panier
   - description repliée, avis Judge.me limités à 3 + « Voir tous les avis »
   ========================================================================== */
(() => {
  if (window.__wlPdp) return;
  window.__wlPdp = true;

  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  };
  const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  const norm = (s) => {
    s = String(s || '').toUpperCase().replace(/\s+/g, '');
    if (s === 'XXL') return '2XL';
    if (s === 'XXXL') return '3XL';
    return s;
  };
  const fmt = (c) => (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  const sizeLabels = () => window.WL_SIZE_LABELS || null;
  const lbl = (v) => {
    const L = sizeLabels();
    return (L && L[v]) || v;
  };

  /* ---------- Données produit ---------- */
  const src = document.querySelector('[data-wl-pdp]') || document.querySelector('[data-wl-ess]');
  const D = src ? src.dataset : {};
  const fit = D.fit || '';

  const meta = document.querySelector('.wl-pt__meta');
  if (meta) {
    const bits = [];
    if (D.fit) bits.push(D.fit);
    if (D.fin && D.fin !== 'Uni') bits.push(D.fin);
    if (+D.gsm) bits.push(D.gsm + ' g/m²');
    else if (D.wt) bits.push('Tissu ' + D.wt.toLowerCase());
    meta.textContent = bits.join(' · ');
  }

  const grid = document.querySelector('[data-ess-grid]');
  if (grid) {
    const FIT = {
      Oversize: 'Ample, épaules tombantes, tombe plus bas',
      Boxy: 'Large et plus court, effet carré',
      Classique: 'Coupe droite, près du corps',
      'Décontractée': 'De l’aisance sans excès',
    };
    const WT = {
      'Léger': 'Frais, idéal été',
      Medium: 'Le polyvalent',
      'Épais': 'Tombé premium, ne colle pas',
    };
    const FIN = {
      'Délavé': 'Effet vintage, chaque pièce est unique',
      'Snow wash': 'Délavage marbré façon neige',
      'Acid wash': 'Délavage acide contrasté',
      'Tie-dye': 'Teinture nouée, motif unique',
      Vintage: 'Rendu usé, look rétro',
      Uni: 'Couleur unie',
    };
    const tiles = [];
    if (D.fit) tiles.push(['Coupe', D.fit, FIT[D.fit]]);
    if (+D.gsm || D.wt) tiles.push(['Épaisseur', +D.gsm ? D.gsm + ' g/m²' : D.wt, D.wt ? D.wt + ' · ' + (WT[D.wt] || '') : '']);
    if (D.fin) tiles.push(['Finition', D.fin, FIN[D.fin]]);
    if (D.gen) tiles.push(['Pour qui', D.gen === 'Mixte' ? 'Unisexe' : D.gen, D.gen === 'Mixte' ? 'Pensé pour elle et lui' : '']);
    grid.innerHTML = tiles
      .map(([k, v, d]) => `<div class="wl-ess__c"><span class="wl-ess__k">${k}</span><span class="wl-ess__v">${v}</span>${d ? `<span class="wl-ess__d">${d}</span>` : ''}</div>`)
      .join('');
  }

  /* ---------- Glo Swatch : français, valeur choisie, conseil taille ---------- */
  const NAMES = { color: 'Couleur', couleur: 'Couleur', colour: 'Couleur', size: 'Taille', taille: 'Taille' };
  // remplace le texte des pilules de taille par le libellé du produit (Glo peut re-rendre la liste)
  const relabel = (g) => {
    g.querySelectorAll('li[data-value] label').forEach((lab) => {
      const t = lbl(lab.closest('li').dataset.value);
      const n = [...lab.childNodes].filter((x) => x.nodeType === 3).pop();
      if (n && n.textContent !== t) n.textContent = t;
    });
  };
  let adviceDone = false;
  const enhanceSwatches = () => {
    const wrap = document.querySelector('.product .globo-swatch-product-detail');
    if (!wrap) return false;
    const groups = [...wrap.querySelectorAll('.swatch--gl[data-option-index]')];
    if (!groups.length) return false;
    groups.forEach((g) => {
      const lg = g.querySelector('legend.name-option');
      if (!lg || lg.dataset.wl) return;
      lg.dataset.wl = '1';
      const key = String(lg.dataset.name || '').toLowerCase();
      const isSize = key === 'size' || key === 'taille';
      const fr = NAMES[key] || lg.dataset.name;
      const first = [...lg.childNodes].find((n) => n.nodeType === 3);
      if (first) first.textContent = fr;
      const sel = document.createElement('span');
      sel.className = 'wl-sel';
      lg.appendChild(sel);
      const upd = () => {
        const c = g.querySelector('input:checked');
        sel.textContent = c ? ': ' + (isSize ? lbl(c.value) : c.value) : '';
      };
      g.addEventListener('change', upd);
      upd();
      if (isSize) {
        g.dataset.wlSize = '1';
        if (sizeLabels()) {
          g.dataset.wlAge = '1';
          relabel(g);
          new MutationObserver(() => relabel(g)).observe(g, { childList: true, subtree: true });
        }
      }
    });

    // Conseil taille (une seule fois)
    const sg = wrap.querySelector('[data-wl-size="1"]');
    if (sg && !adviceDone) {
      adviceDone = true;
      const lis = [...sg.querySelectorAll('li[data-value]')];
      const avail = lis.map((li) => norm(li.dataset.value));
      const my = norm(store.get('wl-size'));
      const over = fit === 'Oversize';
      const box = document.createElement('div');
      box.className = 'wl-fitadv';
      const ico = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M3 7h18v10H3z" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M7 7v4M11 7v3M15 7v4M19 7v3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
      let html = '';
      let advised = null;
      if (sg.dataset.wlAge) {
        // tailles en âge (enfant) : le conseil adulte « Ma taille » ne s'applique pas
        html = '<b>Tailles enfant</b> : choisis selon l’âge. Entre deux tailles, prends la plus grande.';
      } else if (my && SIZE_ORDER.includes(my) && avail.includes(my)) {
        const i = SIZE_ORDER.indexOf(my);
        advised = over ? SIZE_ORDER[Math.max(0, i - 1)] : my;
        if (!avail.includes(advised)) advised = my;
        html = over
          ? `Tu fais du <b>${my}</b> d'habitude ? Cette coupe oversize taille grand : on te conseille le <b>${advised}</b>.`
          : `Tu fais du <b>${my}</b> d'habitude ? Prends ta taille : <b>${advised}</b>.`;
      } else if (over) {
        html = '<b>Coupe oversize, longue de chez longue</b> : prends une taille en dessous de ta taille habituelle.';
      } else if (fit === 'Boxy') {
        html = '<b>Coupe boxy</b> : large et plus courte, prends ta taille habituelle.';
      }
      if (html) {
        box.innerHTML = ico + '<div>' + html + (advised ? `<br><button type="button" data-pick="${advised}">Choisir le ${advised}</button>` : '') + '</div>';
        const lg = sg.querySelector('legend.name-option');
        (lg || sg.firstChild).after(box);
        if (advised) {
          const li = lis.find((x) => norm(x.dataset.value) === advised);
          if (li) li.classList.add('wl-advised');
          box.querySelector('[data-pick]').addEventListener('click', () => {
            const lab = li && li.querySelector('label');
            if (lab) lab.click();
          });
        }
      }
    }
    return true;
  };
  if (!enhanceSwatches()) {
    const mo = new MutationObserver(() => {
      if (enhanceSwatches()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 15000);
  }

  /* ---------- Réassurance : reste pour la livraison offerte ---------- */
  const ras = document.querySelector('[data-wl-ras]');
  const cartLine = ras && ras.querySelector('[data-ras-cart]');
  const refreshCart = () => {
    if (!cartLine) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        const th = +ras.dataset.threshold || 8000;
        const t = c.total_price || 0;
        if (!t) {
          cartLine.hidden = true;
          return;
        }
        cartLine.hidden = false;
        const p = Math.min(100, (t / th) * 100);
        cartLine.innerHTML = (t >= th
          ? 'Ton panier : ' + fmt(t) + ' · <b>livraison offerte</b> ✓'
          : 'Ton panier : ' + fmt(t) + ' · plus que <b>' + fmt(th - t) + '</b> pour la livraison offerte') +
          `<span class="wl-ras__bar"><i style="--p:${p}%"></i></span>`;
      })
      .catch(() => {});
  };
  refreshCart();
  try {
    // eslint-disable-next-line no-undef
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(refreshCart, 200));
  } catch (e) {}
  document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && refreshCart());

  /* ---------- Description repliée ---------- */
  const desc = document.querySelector('[data-wl-desc]');
  const more = document.querySelector('[data-desc-more]');
  if (desc && more) {
    desc.classList.add('is-clamped');
    if (desc.scrollHeight > desc.clientHeight + 20) {
      more.hidden = false;
      more.addEventListener('click', () => {
        desc.classList.remove('is-clamped');
        more.hidden = true;
      });
    } else desc.classList.remove('is-clamped');
  }

  /* ---------- Avis Judge.me : 3 visibles + « Voir tous les avis » ---------- */
  const tameReviews = () => {
    const list = document.querySelector('.product .jdgm-rev-widg__reviews');
    if (!list || list.dataset.wl) return !!list;
    const revs = [...list.querySelectorAll('.jdgm-rev')];
    if (!revs.length) return false;
    list.dataset.wl = '1';
    if (revs.length <= 3) return true;
    revs.slice(3).forEach((r) => r.classList.add('wl-rev-hide'));
    const total = document.querySelector('.product .jdgm-rev-widg')?.dataset.numberOfReviews || revs.length;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'wl-rev-all';
    b.textContent = 'Voir les ' + total + ' avis';
    list.after(b);
    b.addEventListener('click', () => {
      list.querySelectorAll('.wl-rev-hide').forEach((r) => r.classList.remove('wl-rev-hide'));
      b.remove();
    });
    return true;
  };
  if (!tameReviews()) {
    const mo2 = new MutationObserver(() => {
      if (tameReviews()) mo2.disconnect();
    });
    mo2.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo2.disconnect(), 20000);
  }
})();
